/* set to false when deploying */
export const devMode = false;
